import React, {ReactNode} from 'react'

const FormGroup = ({ required, htmlFor, className, formClassName, label, subLabel, children, noFormLabel, isVertical = false, col = 3}: {
  required?: boolean
  htmlFor?: string
  className?: string
  formClassName?: string
  label: ReactNode
  subLabel?: ReactNode
  children: ReactNode
  noFormLabel?: boolean
  isVertical?: boolean
  col?: number
}) => {
  return <>
    {isVertical
      ? <div className={['form-group', formClassName].filter(Boolean).join(' ')}>
        <label
          htmlFor={htmlFor}
          className={[
            'font-weight-bold',
            !noFormLabel && 'col-form-label',
            className,
            required && 'required'
          ].filter(Boolean).join(' ')}>
          {label}
        </label>
        <div className={subLabel && 'd-flex'}>
          {children}
          {subLabel && <div className="align-self-center ml-2 text-nowrap">
            {subLabel}
          </div>}
        </div>
      </div>
      : <div className="form-group row">
        <label
          htmlFor={htmlFor}
          className={[
            `col-md-${col} font-weight-bold text-md-right`,
            !noFormLabel && 'col-form-label',
            className,
            required && 'required'
          ].filter(Boolean).join(' ')}>
          {label}
        </label>
        <div className={`col-md-${12 - col}`}>
          {children}
        </div>
      </div>
    }
  </>
}
FormGroup.displayName = 'FormGroup'
export default FormGroup
